import React, { useEffect, useState } from "react";
import ocrImg from "../../assets/images/service/s6.png";
import OcrDescription from "./OcrDescription";
import OcrEx from "./OcrEx";
import TestApiModal from "../../component/modal/TestApiModal";
import TestAPiMobileModal from "../../component/modal/TestApiMobileModal";
import LoginModal from "../../component/modal/LoginModal";
import { handleModalController } from "../../util/Common";
const OcrService = () => {
  const [showModal, setShowModal] = useState(false);
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [isLoginModal, setLoginModal] = useState(false);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    // 이벤트 리스너 등록
    window.addEventListener("resize", handleResize);

    // cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = () => {
    handleModalController({
      windowWidth,
      setShowModal,
      setShowMobileModal,
      setLoginModal,
    });
  };

  return (
    <>
      <div
        className="row my-5 sercice-details-content align-items-center"
        id="Ocr"
      >
        <div className="col-lg-6 col-12 order-2 order-lg-1">
          <div className="details mt_md--30 mt_sm--30">
            <h4 className="title">광학문자인신(OCR) API</h4>
            <p>
              광학문자인신(OCR)은 텍스트 이미지를 기계가 읽을 수 있는 텍스트
              포멧을 변환하는 과정입니다. 이미지 파일 내 존재하는 텍스트를
              탐색하여 편집, 검색등을 수행할 수 있습니다.
            </p>
            <ul className="liststyle mt-4">
              <li>한글/영어 인식가능</li>
              <li>이미지 내 텍스트 부분의 좌표를 비롯하여 내용을 보여줌</li>
              <li>OCR을 사용하여 다양한 앱/웹 서비스에 활용 가능</li>
            </ul>
          </div>
          <div
            className="slide-btn mt-2"
            style={{
              cursor: `pointer`,
            }}
          >
            <a
              onClick={() => handleClick()}
              className="rn-button-style--2 btn-primary-color"
            >
              신청하기
            </a>
          </div>
        </div>
        <div className="col-lg-6 col-12 order-1 order-lg-2">
          <div className="thumb position-relative">
            <img className="w-100" src={ocrImg} alt="Service Images" />
            {/* <ModalVideo
                    channel="youtube"
                    isOpen={this.state.isOpen}
                    videoId="ZOoVOfieAF8"
                    onClose={() => this.setState({ isOpen: false })}
                    />
                    <button
                    className="video-popup"
                    onClick={this.openModal}
                    > */}
            {/* <span className="play-icon"></span>
                    </button> */}
          </div>
        </div>
      </div>
      <OcrDescription></OcrDescription>
      <TestApiModal isOpen={showModal} onClose={() => setShowModal(false)} />
      <TestAPiMobileModal
        isOpen={showMobileModal}
        onClose={() => setShowMobileModal(false)}
      />
      <div className="row sercice-details-content pb--80 align-items-center">
        <OcrEx></OcrEx>
      </div>
      <LoginModal isOpen={isLoginModal} onClose={() => setLoginModal(false)} />
    </>
  );
};
export default OcrService;
